"use strict";
/**
 * @license
 * Copyright 2022 SOUTHWORKS UK LTD All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/southworks/codeverter/blob/main/LICENSE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Class = void 0;
const typescript_1 = require("typescript");
const class_element_1 = require("./class-element");
class Class extends class_element_1.ClassElement {
    constructor() {
        super(...arguments);
        this.extendsClauses = [];
        this.implementsClauses = [];
    }
    setHeritages(node) {
        var _a;
        (_a = node.heritageClauses) === null || _a === void 0 ? void 0 : _a.forEach(hc => {
            hc.types.forEach(t => {
                if (this.getTypeChecker().getTypeFromTypeNode(t).isClass()) {
                    this.extendsClauses.push(`${t.expression.text}`);
                }
                else {
                    this.implementsClauses.push(`${t.expression.text}`);
                }
            });
        });
    }
    addProperty(node) {
        this.addElement("property", node);
    }
    ;
    addConstructor(node) {
        this.addElement("ctr", node);
    }
    addMethod(node) {
        this.addElement("method", node);
    }
    /**
     * In Typescript can declare a property as a constructor parameter
     */
    addParameterAsProperty(node) {
        this.addElement("property", node);
    }
    parse(node) {
        super.parse(node);
        this.setHeritages(node);
        node.members.forEach(m => {
            if ((0, typescript_1.isPropertyDeclaration)(m)) {
                this.addProperty(m);
            }
            else if ((0, typescript_1.isConstructorDeclaration)(m)) {
                this.addConstructor(m);
            }
            else if ((0, typescript_1.isMethodDeclaration)(m)) {
                this.addMethod(m);
            }
        });
    }
    get variables() {
        return this.getValues("variable");
    }
    get constants() {
        return this.getValues("constant");
    }
    get properties() {
        return this.getValues("property");
    }
    get methods() {
        return this.getValues("method");
    }
    get constructors() {
        return this.getValues("ctr");
    }
    get extends() {
        return this.extendsClauses.map(e => ({ name: e }));
    }
    get implements() {
        return this.implementsClauses.map(e => ({ name: e }));
    }
}
exports.Class = Class;
